import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Button, Checkbox, Divider, Grid, Input, Popup } from 'semantic-ui-react';
import axios from 'axios';
import _debounce from 'lodash/debounce';
import _get from 'lodash/get';
import { CardElement, injectStripe } from 'react-stripe-elements';
import Modal from '../../../modules/foundation/components/Modal';
import { LogRocket } from '../../../services/analytics';
import { BusinessPropType } from '../../../services/proptypes';
import { getBusinessTypePath } from '../../../utils/api';
import { ANNUAL_PRICE_PERIOD } from '../PublishBanner.constants';
import { SubscriptionsContextConsumer } from '../PublishBanner.context';
import { formatCentsToDollars } from '../PublishBanner.formatters';
var TOS = 'https://gofisherman.com/terms-of-service/';
var GENERIC_CHECKOUT_ERROR = 'There was a problem processing your request. Please, try again later or contact support@gofisherman.com.';
var CheckoutForm = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckoutForm, _React$Component);
  var _super = _createSuper(CheckoutForm);
  function CheckoutForm(props) {
    var _this;
    _classCallCheck(this, CheckoutForm);
    _this = _super.call(this, props);
    _this.state = {
      couponCode: null,
      couponCodeValid: true,
      cardDataIsComplete: false,
      cancelToken: undefined,
      firstName: null,
      lastName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      email: props.email || null,
      phoneNumber: null,
      termsAccepted: false,
      submitEnabled: false,
      checkoutLoading: false,
      showErrorMessage: false,
      error: null
    };
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.onCardChange = _this.onCardChange.bind(_assertThisInitialized(_this));
    _this.onCouponChanged = _this.onCouponChanged.bind(_assertThisInitialized(_this));
    _this.onFieldChange = _this.onFieldChange.bind(_assertThisInitialized(_this));
    _this.onZipCodeChanged = _this.onZipCodeChanged.bind(_assertThisInitialized(_this));
    _this.onPhoneNumberChanged = _this.onPhoneNumberChanged.bind(_assertThisInitialized(_this));
    _this.onLoadCompleted = _this.onLoadCompleted.bind(_assertThisInitialized(_this));
    _this.checkInputs = _this.checkInputs.bind(_assertThisInitialized(_this));
    _this.onCheckoutError = _this.onCheckoutError.bind(_assertThisInitialized(_this));
    _this.checkCouponDebounced = _debounce(_this.checkCoupon, 1000);
    _this.toggleTerms = _this.toggleTerms.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CheckoutForm, [{
    key: "onCardChange",
    value: function onCardChange(data) {
      this.cleanCheckoutError();
      var _data$complete = data.complete,
        complete = _data$complete === void 0 ? false : _data$complete;
      var error = _get(data, 'error.message', null);
      var showErrorMessage = !!error;
      this.setState({
        cardDataIsComplete: complete,
        error: error,
        showErrorMessage: showErrorMessage
      });
      this.checkInputs();
    }
  }, {
    key: "onCouponChanged",
    value: function onCouponChanged(e, _ref) {
      var _this2 = this;
      var value = _ref.value;
      this.setState({
        couponCode: value.trim(),
        couponCodeValid: true
      }, function () {
        _this2.cleanCheckoutError();
        _this2.checkCouponDebounced();
        _this2.checkInputs();
      });
    }
  }, {
    key: "onFieldChange",
    value: function onFieldChange(fieldName, value) {
      var _this3 = this;
      this.cleanCheckoutError();
      this.setState(_defineProperty({}, fieldName, value), function () {
        _this3.checkInputs();
      });
    }
  }, {
    key: "onZipCodeChanged",
    value: function onZipCodeChanged(e, _ref2) {
      var _this4 = this;
      var value = _ref2.value;
      this.cleanCheckoutError();
      var onlyAlphanumeric = value.replaceAll(/[^a-zA-Z0-9]/g, '');
      this.setState({
        zipCode: onlyAlphanumeric
      }, function () {
        _this4.checkInputs();
      });
    }
  }, {
    key: "onPhoneNumberChanged",
    value: function onPhoneNumberChanged(e, _ref3) {
      var _this5 = this;
      var value = _ref3.value;
      this.cleanCheckoutError();
      var onlyNumbers = value.replaceAll(/[^0-9]/g, '');
      this.setState({
        phoneNumber: onlyNumbers
      }, function () {
        _this5.checkInputs();
      });
    }
  }, {
    key: "onLoadCompleted",
    value: function onLoadCompleted() {
      this.setState({
        checkoutLoading: false
      });
    }
  }, {
    key: "onCheckoutError",
    value: function onCheckoutError(error) {
      this.setState({
        showErrorMessage: true,
        error: error
      });
      this.onLoadCompleted();
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(subscriptionPlanId) {
        var _this6 = this;
        var _this$props, business, stripe, onCheckoutCompleted, chosenDomain, customDomain, _this$state, firstName, lastName, address, city, state, zipCode, email, phoneNumber, couponCode, couponCodeValid, stripeCardholderData, _yield$stripe$createT, token, error, url, headers, errorMessage, domainType, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setState({
                checkoutLoading: true,
                error: null
              });
              _this$props = this.props, business = _this$props.business, stripe = _this$props.stripe, onCheckoutCompleted = _this$props.onCheckoutCompleted, chosenDomain = _this$props.chosenDomain, customDomain = _this$props.customDomain;
              _this$state = this.state, firstName = _this$state.firstName, lastName = _this$state.lastName, address = _this$state.address, city = _this$state.city, state = _this$state.state, zipCode = _this$state.zipCode, email = _this$state.email, phoneNumber = _this$state.phoneNumber, couponCode = _this$state.couponCode, couponCodeValid = _this$state.couponCodeValid;
              stripeCardholderData = {
                name: "".concat(firstName, " ").concat(lastName),
                address_line1: address,
                address_city: city,
                address_state: state,
                address_zip: zipCode
              };
              _context.next = 6;
              return stripe.createToken(stripeCardholderData);
            case 6:
              _yield$stripe$createT = _context.sent;
              token = _yield$stripe$createT.token;
              error = _yield$stripe$createT.error;
              url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
              headers = {
                'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
              }; // Stripe createToken error handling
              if (!error) {
                _context.next = 16;
                break;
              }
              errorMessage = error.message || 'There was an error in your payment information. Please check your card data. If this issue persist, please contact support@gofisherman.com';
              LogRocket.captureMessage(errorMessage, {
                extra: _objectSpread({}, stripeCardholderData)
              });
              this.onCheckoutError(errorMessage);
              return _context.abrupt("return");
            case 16:
              domainType = Object.keys(chosenDomain).length > 0 ? 'internal' : 'external';
              data = {
                stripe_token: token.id,
                stripe_subscription_plan: subscriptionPlanId,
                customer: {
                  firstName: firstName,
                  lastName: lastName,
                  address: address,
                  city: city,
                  state: state,
                  zipCode: zipCode,
                  email: email,
                  phoneNumber: phoneNumber
                },
                domain: domainType === 'internal' ? chosenDomain.DomainName : customDomain,
                domainType: domainType
              };
              if (couponCode && couponCode.length > 0 && couponCodeValid) {
                data.coupon = couponCode;
              }
              axios.post("".concat(url, "businesses/").concat(getBusinessTypePath(business.type), "/").concat(business.id, "/subscriptions/"), data, {
                headers: headers
              }).then(function () {
                _this6.onLoadCompleted();
                onCheckoutCompleted();
              })["catch"](function (err) {
                _this6.onLoadCompleted();
                if (err.response) {
                  var errorMsg = null;
                  var responseStatus = _get(err, 'response.status');
                  if (responseStatus === 304) {
                    errorMsg = 'Customer already exists for this card, please contact support@gofisherman.com';
                  }
                  if (responseStatus >= 400) {
                    errorMsg = _get(err, 'response.data.message') || GENERIC_CHECKOUT_ERROR;
                  }
                  if (responseStatus >= 500) {
                    LogRocket.captureError(err);
                  }
                  _this6.onCheckoutError(errorMsg);
                } else if (err.request) {
                  var _errorMsg = 'We are experiencing issues connecting to our payments provider. You have not been charged. Please check your internet connection and try again.';
                  _this6.onCheckoutError(_errorMsg);
                  LogRocket.captureError(err);
                } else {
                  LogRocket.captureError(err);
                }
              });
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, {
    key: "getDisabledSubmitCause",
    value: function getDisabledSubmitCause() {
      var _this$state2 = this.state,
        termsAccepted = _this$state2.termsAccepted,
        couponCodeValid = _this$state2.couponCodeValid,
        cardDataIsComplete = _this$state2.cardDataIsComplete;
      if (!termsAccepted) {
        return 'You must accept the Terms of Use to complete the payment';
      }
      if (!couponCodeValid) {
        return 'Please add a valid coupon code or leave it blank';
      }
      if (!cardDataIsComplete) {
        return 'Please check your card information';
      }
      return 'Please fill all the information in the form';
    }
  }, {
    key: "toggleTerms",
    value: function toggleTerms() {
      var _this7 = this;
      this.setState(function (prevState) {
        return {
          termsAccepted: !prevState.termsAccepted
        };
      }, function () {
        return _this7.checkInputs();
      });
    }
  }, {
    key: "cleanCheckoutError",
    value: function cleanCheckoutError() {
      this.setState({
        showErrorMessage: false,
        error: null
      });
    }
  }, {
    key: "checkInputs",
    value: function checkInputs() {
      var _this$state3 = this.state,
        firstName = _this$state3.firstName,
        lastName = _this$state3.lastName,
        address = _this$state3.address,
        city = _this$state3.city,
        state = _this$state3.state,
        zipCode = _this$state3.zipCode,
        email = _this$state3.email,
        phoneNumber = _this$state3.phoneNumber,
        termsAccepted = _this$state3.termsAccepted,
        couponCodeValid = _this$state3.couponCodeValid,
        cardDataIsComplete = _this$state3.cardDataIsComplete;
      var submitEnabled = firstName && lastName && address && city && state && zipCode && email && phoneNumber && termsAccepted && cardDataIsComplete && couponCodeValid;
      this.setState({
        submitEnabled: submitEnabled
      });
    }
  }, {
    key: "checkCoupon",
    value: function () {
      var _checkCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$state4, couponCode, cancelToken, url, headers, newCancelToken, data, response, responseData, _responseData, couponCodeError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$state4 = this.state, couponCode = _this$state4.couponCode, cancelToken = _this$state4.cancelToken;
              url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
              headers = {
                'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
              }; // Check if there are any previous pending requests
              if (cancelToken !== undefined) {
                cancelToken.cancel('Operation canceled due to new request.');
              }
              if (couponCode) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              // Save the cancel token for the current request
              newCancelToken = axios.CancelToken.source();
              this.setState({
                cancelToken: newCancelToken
              });
              data = {
                code: couponCode
              };
              _context2.prev = 9;
              _context2.next = 12;
              return axios.post("".concat(url, "businesses/discounts/check/"), data, {
                headers: headers,
                cancelToken: newCancelToken.token
              });
            case 12:
              response = _context2.sent;
              responseData = response.data;
              this.setState({
                couponCodeValid: true,
                couponCodeDescription: responseData.description
              });
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](9);
              if (_context2.t0.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                _responseData = _context2.t0.response.data;
                couponCodeError = 'Invalid Coupon';
                if (_responseData && _responseData.error) {
                  couponCodeError = _responseData.error;
                }
                this.setState({
                  couponCodeValid: false,
                  couponCodeDescription: undefined,
                  couponCodeError: couponCodeError
                });
              } else {
                // The request was made but no response was received or something
                // else happened: err.request or err.message can have more info
                this.setState({
                  couponCodeValid: false,
                  couponCodeDescription: undefined,
                  couponCodeError: "We couldn't validate the coupon. Check your internet connection and try again."
                });
                LogRocket.captureError(_context2.t0);
              }
            case 20:
              _context2.prev = 20;
              this.checkInputs();
              return _context2.finish(20);
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 17, 20, 23]]);
      }));
      function checkCoupon() {
        return _checkCoupon.apply(this, arguments);
      }
      return checkCoupon;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var chosenDomain = this.props.chosenDomain;
      var _this$state5 = this.state,
        submitEnabled = _this$state5.submitEnabled,
        checkoutLoading = _this$state5.checkoutLoading,
        showErrorMessage = _this$state5.showErrorMessage,
        error = _this$state5.error,
        couponCode = _this$state5.couponCode,
        couponCodeValid = _this$state5.couponCodeValid,
        couponCodeDescription = _this$state5.couponCodeDescription,
        couponCodeError = _this$state5.couponCodeError,
        firstName = _this$state5.firstName,
        lastName = _this$state5.lastName,
        address = _this$state5.address,
        city = _this$state5.city,
        state = _this$state5.state,
        zipCode = _this$state5.zipCode,
        email = _this$state5.email,
        phoneNumber = _this$state5.phoneNumber,
        termsAccepted = _this$state5.termsAccepted;
      return /*#__PURE__*/React.createElement(SubscriptionsContextConsumer, null, function (_ref4) {
        var selectedSubscription = _ref4.selectedSubscription,
          selectedPeriod = _ref4.selectedPeriod;
        var monthlyPrice = selectedSubscription.monthlyPrice,
          annualPrice = selectedSubscription.annualPrice,
          priceName = selectedSubscription.priceName,
          priceIds = selectedSubscription.priceIds;
        var isAnnual = selectedPeriod === ANNUAL_PRICE_PERIOD;
        var totalAmount = isAnnual ? formatCentsToDollars(monthlyPrice * 12) : formatCentsToDollars(monthlyPrice);
        var discount = isAnnual ? formatCentsToDollars(monthlyPrice * 12 - annualPrice) : 0;
        var finalAmount = totalAmount - discount;
        var finalPriceId = priceIds[selectedPeriod];
        var planDisplayName = priceName + (isAnnual ? ' x 12 months' : ' x 1 month');
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
          className: "modal-header"
        }, "Checkout"), /*#__PURE__*/React.createElement(Grid, {
          stackable: true,
          className: "checkout checkout-body"
        }, /*#__PURE__*/React.createElement(Grid.Row, {
          className: "checkout-payment-heading-row"
        }, /*#__PURE__*/React.createElement(Grid.Column, {
          computer: 8,
          tablet: 8,
          mobile: 16,
          className: "checkout-border checkout-payment-details",
          id: "checkout-payment-details-firstcol"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "header-text blue-color"
        }, "Payment Details"), /*#__PURE__*/React.createElement(Divider, {
          className: "checkout-divider"
        }), /*#__PURE__*/React.createElement("p", {
          className: "checkout-subheader body-text blue-color"
        }, "Billing Information"), /*#__PURE__*/React.createElement(CardElement, {
          className: "stripe-checkout-input",
          onChange: _this8.onCardChange
        }), /*#__PURE__*/React.createElement(Input, {
          value: couponCode,
          id: "coupon-code-input",
          className: "checkout-input",
          placeholder: "Coupon Code",
          onChange: _this8.onCouponChanged
        }), couponCode && couponCode.length > 0 && !couponCodeValid && /*#__PURE__*/React.createElement("p", {
          style: {
            color: 'red'
          }
        }, couponCodeError), couponCode && couponCodeDescription && /*#__PURE__*/React.createElement("p", null, "Code unlocked: ", couponCodeDescription), /*#__PURE__*/React.createElement(Divider, {
          className: "checkout-divider"
        }), /*#__PURE__*/React.createElement("p", {
          className: "checkout-subheader body-text blue-color"
        }, "Billing Address"), /*#__PURE__*/React.createElement(Input, {
          value: firstName,
          id: "first-name-input",
          className: "checkout-input check-input-half check-input-half-first",
          placeholder: "First Name",
          onChange: function onChange(_, _ref5) {
            var value = _ref5.value;
            return _this8.onFieldChange('firstName', value);
          }
        }), /*#__PURE__*/React.createElement(Input, {
          value: lastName,
          id: "last-name-input",
          className: "checkout-input check-input-half",
          placeholder: "Last Name",
          onChange: function onChange(_, _ref6) {
            var value = _ref6.value;
            return _this8.onFieldChange('lastName', value);
          }
        }), /*#__PURE__*/React.createElement(Input, {
          value: address,
          id: "address-input",
          className: "checkout-input",
          placeholder: "Address",
          onChange: function onChange(_, _ref7) {
            var value = _ref7.value;
            return _this8.onFieldChange('address', value);
          }
        }), /*#__PURE__*/React.createElement(Input, {
          value: city,
          id: "city-input",
          className: "checkout-input check-input-half check-input-half-first",
          placeholder: "City",
          onChange: function onChange(_, _ref8) {
            var value = _ref8.value;
            return _this8.onFieldChange('city', value);
          }
        }), /*#__PURE__*/React.createElement(Input, {
          calue: state,
          id: "state-input",
          className: "checkout-input checkout-input-quarter checkout-input-quarter-first",
          placeholder: "State",
          onChange: function onChange(_, _ref9) {
            var value = _ref9.value;
            return _this8.onFieldChange('state', value);
          }
        }), /*#__PURE__*/React.createElement(Input, {
          value: zipCode,
          id: "zip-code-input",
          className: "checkout-input checkout-input-quarter",
          placeholder: "Zip Code",
          onChange: _this8.onZipCodeChanged,
          input: /*#__PURE__*/React.createElement("input", {
            maxLength: "6"
          })
        }), /*#__PURE__*/React.createElement(Input, {
          value: email,
          id: "email-input",
          className: "checkout-input check-input-half check-input-half-first",
          placeholder: "Email",
          onChange: function onChange(_, _ref10) {
            var value = _ref10.value;
            return _this8.onFieldChange('email', value);
          }
        }), /*#__PURE__*/React.createElement(Input, {
          value: phoneNumber,
          id: "phone-number-input",
          className: "checkout-input check-input-half",
          placeholder: "Phone Number",
          onChange: _this8.onPhoneNumberChanged,
          input: /*#__PURE__*/React.createElement("input", {
            maxLength: "20"
          })
        })), /*#__PURE__*/React.createElement(Grid.Column, {
          computer: 1,
          tablet: 1,
          only: "computer tablet"
        }), /*#__PURE__*/React.createElement(Grid.Column, {
          computer: 7,
          tablet: 7,
          mobile: 16,
          className: "checkout-border checkout-payment-details"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "header-text blue-color"
        }, "Order Summary"), /*#__PURE__*/React.createElement("p", null, "Once you place the order, we\u2019ll connect your website to your selected domain and notify you when the site is live. If you have an existing domain, someone from our team will contact you to connect it."), /*#__PURE__*/React.createElement(Divider, {
          className: "checkout-divider"
        }), /*#__PURE__*/React.createElement("div", {
          className: "body-text blue-color checkout-row"
        }, /*#__PURE__*/React.createElement("p", {
          className: "checkout-row-right"
        }, "$", totalAmount), /*#__PURE__*/React.createElement("p", null, planDisplayName)), discount !== 0 && /*#__PURE__*/React.createElement("div", {
          className: "body-text blue-color checkout-row"
        }, /*#__PURE__*/React.createElement("p", {
          className: "checkout-row-right"
        }, "-$", discount), /*#__PURE__*/React.createElement("p", null, "Annual plan savings")), chosenDomain.DomainName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "body-text blue-color checkout-row"
        }, /*#__PURE__*/React.createElement("p", {
          className: "checkout-row-right strike-through-text"
        }, "$15"), /*#__PURE__*/React.createElement("p", null, "Domain Service")), /*#__PURE__*/React.createElement("div", {
          className: "checkout-row checkout-domain-description checkout-row"
        }, /*#__PURE__*/React.createElement("p", {
          className: "checkout-row-right green-color"
        }, "FREE"), /*#__PURE__*/React.createElement("p", null, chosenDomain.DomainName || /*#__PURE__*/React.createElement("div", null, "\xA0")))), /*#__PURE__*/React.createElement("div", {
          className: "blue-color checkout-row"
        }, /*#__PURE__*/React.createElement("p", {
          className: "checkout-row-right bolded"
        }, "$", finalAmount), /*#__PURE__*/React.createElement("p", {
          className: "checkout-row-left bolded"
        }, "Total")), /*#__PURE__*/React.createElement("div", {
          className: "terms-of-use"
        }, /*#__PURE__*/React.createElement(Checkbox, {
          label: /*#__PURE__*/React.createElement("label", {
            style: {
              fontSize: 16
            }
          }, "I agree to Fisherman\u2019s", ' ', /*#__PURE__*/React.createElement("a", {
            className: "tos-link",
            href: TOS,
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Terms and Conditions")),
          onChange: _this8.toggleTerms,
          value: termsAccepted
        })), submitEnabled ? /*#__PURE__*/React.createElement(Button, {
          style: {
            border: '2px solid red !important',
            width: '100%'
          },
          className: "centered-button checkout-button-enabled",
          onClick: function onClick() {
            return _this8.onSubmit(finalPriceId);
          },
          loading: checkoutLoading
        }, "Place Order") : /*#__PURE__*/React.createElement(Popup, {
          content: _this8.getDisabledSubmitCause(),
          trigger: /*#__PURE__*/React.createElement(Button, {
            className: "centered-button checkout-button-disabled"
          }, "Place Order")
        }), showErrorMessage && /*#__PURE__*/React.createElement("p", {
          className: "error-message centered-content"
        }, error || GENERIC_CHECKOUT_ERROR)))));
      });
    }
  }]);
  return CheckoutForm;
}(React.Component);
CheckoutForm.defaultProps = {
  customDomain: null,
  email: null
};
export default injectStripe(CheckoutForm);